import { create } from 'zustand';
import type { AuthPayload, AuthUser } from '../api/types';
import { storage } from '../lib/storage';

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  isAuthenticated: boolean;
  hydrate: () => void;
  setSession: (payload: AuthPayload) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  hydrate: () => {
    const token = storage.getToken();
    const raw = storage.getUser();
    const user = raw ? { ...raw, guid: raw.guid ?? raw.id } : null;
    set({
      token,
      user,
      isAuthenticated: Boolean(token && user?.guid),
    });
  },

  setSession: (payload) => {
    // Сервер присылает `user.id` (UUID), не `user.guid`. Нормализуем, чтобы
    // остальной код мог работать с единым полем `guid`.
    const user = {
      ...payload.user,
      guid: payload.user.guid ?? payload.user.id,
    };
    storage.setToken(payload.auth.access.token);
    storage.setUser(user);
    set({
      token: payload.auth.access.token,
      user,
      isAuthenticated: true,
    });
  },

  clearSession: () => {
    storage.clear();
    set({ token: null, user: null, isAuthenticated: false });
  },
}));
